
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: block;
}

.pager {

    margin-bottom: 4rem;

    font-family: var(--ff-display);
}

.pager__items {

    display: flex;

    width: 100%;

    align-items: center;

    justify-content: center;

    padding: 0px;
}

.pager__items .pager__item {

    list-style-type: none;
}

.pager__items .pager__item .pager__link {

    margin-left: 0.25rem;

    margin-right: 0.25rem;
}

.pager__items .pager__item .pager__link {

    display: flex;
}

.pager__items .pager__item .pager__link {

    height: 2.75rem;
}

.pager__items .pager__item .pager__link {

    width: 2.75rem;
}

.pager__items .pager__item .pager__link {

    cursor: pointer;
}

.pager__items .pager__item .pager__link {

    align-items: center;
}

.pager__items .pager__item .pager__link {

    justify-content: center;
}

.pager__items .pager__item .pager__link {

    border-radius: 9999px;
}

.pager__items .pager__item .pager__link {

    border-width: 2px;
}

.pager__items .pager__item .pager__link {

    border-style: solid;
}

.pager__items .pager__item .pager__link {

    border-color: var(--primary-blue-light-1);
}

.pager__items .pager__item .pager__link {

    font-size: var(--fs-xl);

    line-height: var(--lh-xl);
}

.pager__items .pager__item .pager__link {

    font-weight: var(--fw-semibold);
}

.pager__items .pager__item .pager__link {

    color: var(--primary-blue);
}

.pager__items .pager__item .pager__link {

    text-decoration-line: none;
}

.pager__items .pager__item .pager__link {

    transition-duration: 200ms;
}

.pager__items .pager__item .pager__link:hover {

    border-color: var(--primary-blue-light-3);
}

.pager__items .pager__item .pager__link:hover {

    color: var(--primary-blue-light-3);
}

.pager__items .pager__item--active .pager__link {

    cursor: default;
}

.pager__items .pager__item--active .pager__link {

    border-color: var(--primary-blue-light-3);
}

.pager__items .pager__item--active .pager__link {

    background-color: var(--primary-blue-light-3);
}

.pager__items .pager__item--active .pager__link {

    color: var(--neutral-white);
}

.pager__items .pager__item--active .pager__link:hover {

    color: var(--neutral-white);
}

.pager__items .pager__item--active .pager__link:hover {

    text-decoration-line: none;
}

.pager__item-title {

    display: none;
}

.pager__item.pager__item--number:not(.pager__item--active) {

    display: none;
}

@media (min-width: 768px) {

    .pager__item.pager__item--number:not(.pager__item--active) {

        display: block;
    }
}

:host([site='BH']) .pager {

    font-family: var(--bh-ff-body);
}

:host([site='BH']) .pager__items .pager__item .pager__link {

    height: 3rem;
}

:host([site='BH']) .pager__items .pager__item .pager__link {

    width: 3rem;
}

:host([site='BH']) .pager__items .pager__item .pager__link {

    border-radius: 0.375rem;
}

:host([site='BH']) .pager__items .pager__item .pager__link {

    border-width: 1px;
}

:host([site='BH']) .pager__items .pager__item .pager__link {

    border-color: var(--bh-neutral-default);
}

:host([site='BH']) .pager__items .pager__item .pager__link {

    font-size: var(--fs-base);

    line-height: var(--lh-base);
}

:host([site='BH']) .pager__items .pager__item .pager__link {

    font-weight: var(--fw-normal);
}

:host([site='BH']) .pager__items .pager__item .pager__link {

    color: var(--bh-neutral-black);
}

:host([site='BH']) .pager__items .pager__item .pager__link.pager__link--action-link {

    border-style: none;
}

:host([site='BH']) .pager__items .pager__item .pager__link.pager__link--action-link {

    color: var(--bh-brand-primary-default);
}

:host([site='BH']) .pager__items .pager__item .pager__link.pager__link--action-link:hover {

    border-width: 1px;
}

:host([site='BH']) .pager__items .pager__item .pager__link.pager__link--action-link:hover {

    border-style: solid;
}

:host([site='BH']) .pager__items .pager__item .pager__link.pager__link--action-link:hover {

    border-color: var(--bh-brand-primary-default);
}

:host([site='BH']) .pager__items .pager__item .pager__link.pager__link--action-link:hover {

    color: var(--bh-brand-primary-dark);
}

:host([site='BH']) .pager__items .pager__item .pager__link:hover {

    border-color: var(--bh-brand-primary-default);
}

:host([site='BH']) .pager__items .pager__item .pager__link:hover {

    color: var(--bh-brand-primary-dark);
}

:host([site='BH']) .pager__items .pager__item--active .pager__link {

    background-color: var(--bh-brand-primary-default);
}

:host([site='BH']) .pager__items .pager__item--active .pager__link {

    color: var(--bh-neutral-white);
}

:host([site='BH']) .pager__items .pager__item--active .pager__link:hover {

    border-color: var(--bh-neutral-default);
}

:host([site='BH']) .pager__items .pager__item--active .pager__link:hover {

    color: var(--bh-neutral-white);
}

:host([site='BH']) .pager__item.pager__item--number {

    display: none;
}

@media (min-width: 768px) {

    :host([site='BH']) .pager__item.pager__item--number {

        display: block;
    }
}

:host([site='BH']) .pager__item.pager__item--number.mobile-show {

    display: block;
}
`;